// src/utils/billingUtils.js
import { formatDuration } from './utilities';
export function aggregateData (billingsFromRepo) {
	const aggregatedData = {};

	for (const entry of billingsFromRepo) {
		if (entry.id === 0) {
			break;
		} // in this case exit from loop
		const hospitalId = entry.hospitalData.id;

		if (!(hospitalId in aggregatedData)) {
			aggregatedData[hospitalId] = {
				counter: 0,
				rpmCounter: 0,
				rtmCounter: 0,
				ccmCounter: 0,
				counter99453: 0,
				percent99453: 0.0,
				counter99445: 0,
				percent99445: 0.0,
				counter99454: 0,
				percent99454: 0.0,
				counter99470: 0,
				percent99470: 0.0,
				counter99457: 0,
				percent99457: 0.0,
				counter994581st: 0,
				percent994581st: 0.0,
				counter994582nd: 0,
				percent994582nd: 0.0,
				counter99490: 0,
				percent99490: 0,
				counter994391st: 0,
				percent994391st: 0,
				counter994392nd: 0,
				percent994392nd: 0,
				counter99487: 0,
				percent99487: 0,
				counter99489: 0,
				percent99489: 0,
				counter99491: 0,
				percent99491: 0,
				counter99437: 0,
				percent99437: 0,
			};
		}

		aggregatedData[hospitalId].counter++;
		if (entry.patientData.isRpmEnabled) aggregatedData[hospitalId].rpmCounter++;
		if (entry.patientData.isRtmEnabled) aggregatedData[hospitalId].rtmCounter++;
		if (entry.patientData.isCcmEnabled) aggregatedData[hospitalId].ccmCounter++;

		if (entry.cptCode99453?.status === 1) {
			aggregatedData[hospitalId].counter99453++;
		}
		if (entry.cptCode99445?.status) {
			aggregatedData[hospitalId].counter99445++;
		}
		if (entry.cptCode99454?.status) {
			aggregatedData[hospitalId].counter99454++;
		}
		if (entry.cptCode99470?.status) {
			aggregatedData[hospitalId].counter99470++;
		}
		if (entry.cptCode99457?.status === 1) {
			aggregatedData[hospitalId].counter99457++;
		}
		if (entry.cptCode99458First?.status === 1) {
			aggregatedData[hospitalId].counter994581st++;
		}
		if (entry.cptCode99458Second?.status === 1) {
			aggregatedData[hospitalId].counter994582nd++;
		}
		if (entry.groupedCcmBillingCodes) {
			const ccmCodes = entry.groupedCcmBillingCodes;
			if (ccmCodes.cptCode99437?.status) {
				aggregatedData[hospitalId].counter99437++;
			}
			if (ccmCodes.cptCode99439First?.status) {
				aggregatedData[hospitalId].counter99439First++;
			}
			if (ccmCodes.cptCode99439Second?.status) {
				aggregatedData[hospitalId].counter99439Second++;
			}
			if (ccmCodes.cptCode99487?.status) {
				aggregatedData[hospitalId].counter99487++;
			}
			if (ccmCodes.cptCode99489?.status) {
				aggregatedData[hospitalId].counter99489++;
			}
			if (ccmCodes.cptCode99490?.status) {
				aggregatedData[hospitalId].counter99490++;
			}
			if (ccmCodes.cptCode99491?.status) {
				aggregatedData[hospitalId].counter99491++;
			}
		}
	}

	for (const hospitalId in aggregatedData) {
		const totalCounter = aggregatedData[hospitalId].counter;
		if (totalCounter > 0) {
			aggregatedData[hospitalId].percent99453 = (
				(aggregatedData[hospitalId].counter99453 / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent99445 = (
				(aggregatedData[hospitalId].counter99445 / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent99454 = (
				(aggregatedData[hospitalId].counter99454 / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent99470 = (
				(aggregatedData[hospitalId].counter99470 / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent99457 = (
				(aggregatedData[hospitalId].counter99457 / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent994581st = (
				(aggregatedData[hospitalId].counter994581st / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent994582nd = (
				(aggregatedData[hospitalId].counter994582nd / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent99437 = (
				(aggregatedData[hospitalId].counter99437 / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent994391st = (
				(aggregatedData[hospitalId].counter994391st / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent994392nd = (
				(aggregatedData[hospitalId].counter994392nd / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent99487 = (
				(aggregatedData[hospitalId].counter99487 / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent99489 = (
				(aggregatedData[hospitalId].counter99489 / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent99490 = (
				(aggregatedData[hospitalId].counter99490 / totalCounter) *
				100
			).toFixed(1);
			aggregatedData[hospitalId].percent99491 = (
				(aggregatedData[hospitalId].counter99491 / totalCounter) *
				100
			).toFixed(1);
		}
	}
	billingsFromRepo.forEach((patient) => {
		let percent99453 = 0;
		let totalMeasurements99453 = 0;
		let percent99445 = 0;
		let totalMeasurements99445 = 0;
		let percent99454 = 0;
		let totalMeasurements99454 = 0;
		let measurement99445IsBillable = false;
		let measurement99454IsBillable = false;
		let measurement99470IsBillable = false;
		let measurement99457IsBillable = false;
		let measurement994581stIsBillable = false;
		let measurement994582ndIsBillable = false;
		if (patient.cptCode99453 !== null) {
			if (patient.cptCode99453.totalMeasurements < 16) {
				percent99453 = ((patient.cptCode99453.totalMeasurements / 16) * 100).toFixed(0);
				totalMeasurements99453 = patient.cptCode99453.totalMeasurements;
			} else {
				totalMeasurements99453 = patient.cptCode99453.totalMeasurements;
				percent99453 = 100;
				measurement99454IsBillable = true;
			}
		}

		if (patient.cptCode99445 !== null) {
			if (patient.cptCode99445.totalMeasurements > 1 && patient.cptCode99445.totalMeasurements < 16) {
				percent99445 = 100;
				totalMeasurements99445 = patient.cptCode99445.totalMeasurements;
				measurement99445IsBillable = true;
			}
		}

		if (patient.cptCode99454 !== null) {
			if (patient.cptCode99454.totalMeasurements < 16) {
				percent99454 = ((patient.cptCode99454.totalMeasurements / 16) * 100).toFixed(0);
				totalMeasurements99454 = patient.cptCode99454.totalMeasurements;
			} else {
				totalMeasurements99454 = patient.cptCode99454.totalMeasurements;
				percent99454 = 100;
				measurement99454IsBillable = true;
			}
		}

		const totalSec =
			patient.cptCode99457?.totalIntervalInSeconds +
			patient.cptCode99458First?.totalIntervalInSeconds +
			patient.cptCode99458Second?.totalIntervalInSeconds;

		let percent99470 = 0;
		let percent99457 = 0;
		let percent994581st = 0;
		let percent994582nd = 0;

		let seconds99470 = 0;
		let seconds99457 = 0;
		let seconds994581st = 0;
		let seconds994582nd = 0;

		if (totalSec < 600) {
			seconds99470 = totalSec;
			percent99470 = (totalSec / 600) * 100 < 100 ? ((totalSec / 600) * 100).toFixed(1) : 100;
			measurement99470IsBillable = false;
		} else if (totalSec < 1200) {
			seconds99470 = totalSec;
			measurement99470IsBillable = true;
			percent99470 = 100;
		}

		if (totalSec < 1200) {
			seconds99457 = totalSec;
			percent99457 = totalSec / 12 < 100 ? (totalSec / 12).toFixed(1) : 100;
		} else if (totalSec < 2400) {
			seconds99457 = 1200;
			percent99457 = 100;
			measurement99457IsBillable = true;

			seconds994581st = totalSec - 1200;
			percent994581st = seconds994581st / 12 < 100 ? (seconds994581st / 12).toFixed(0) : 100;
		} else if (totalSec < 3600) {
			seconds99457 = 1200;
			percent99457 = 100;
			measurement99457IsBillable = true;

			seconds994581st = 1200;
			percent994581st = 100;
			measurement994581stIsBillable = true;

			seconds994582nd = totalSec - 2400;
			percent994582nd = seconds994582nd / 12 < 100 ? (seconds994582nd / 12).toFixed(0) : 100;
		} else if (totalSec >= 3600) {
			seconds99457 = 1200;
			percent99457 = 100;
			measurement99457IsBillable = true;

			seconds994581st = 1200;
			percent994581st = 100;
			measurement994581stIsBillable = true;

			seconds994582nd = totalSec - 2400;
			percent994582nd = 100;
			measurement994582ndIsBillable = true;
		}

		let seconds99490 = 0;
		let percent99490 = 0;
		let seconds994391st = 0;
		let percent994391st = 0;
		let seconds994392nd = 0;
		let percent994392nd = 0;
		let seconds99487 = 0;
		let percent99487 = 0;
		let seconds99489 = 0;
		let percent99489 = 0;
		let seconds99491 = 0;
		let percent99491 = 0;
		let seconds99437 = 0;
		let percent99437 = 0;

		if (patient.groupedCcmBillingCodes !== null) {
			const nonComplexTotalTimeSpent =
				patient.groupedCcmBillingCodes.cptCode99490?.totalIntervalInSeconds +
				patient.groupedCcmBillingCodes.cptCode99439First?.totalIntervalInSeconds +
				patient.groupedCcmBillingCodes.cptCode99439Second?.totalIntervalInSeconds;

			if (nonComplexTotalTimeSpent < 1200) {
				seconds99490 = nonComplexTotalTimeSpent;
				percent99490 = ((seconds99490 / 1200) * 100).toFixed(1);

				seconds994391st = 0;
				percent994391st = 0;

				seconds994392nd = 0;
				percent994392nd = 0;
			}

			if (nonComplexTotalTimeSpent >= 1200 && nonComplexTotalTimeSpent < 2400) {
				seconds99490 = 1200;
				percent99490 = 100;

				seconds994391st = nonComplexTotalTimeSpent - 1200;
				percent994391st = ((seconds994391st / 1200) * 100).toFixed(0);

				seconds994392nd = 0;
				percent994392nd = 0;
			}

			if (nonComplexTotalTimeSpent >= 2400 && nonComplexTotalTimeSpent < 3600) {
				seconds99490 = 1200;
				percent99490 = 100;

				seconds994391st = 1200;
				percent994391st = 100;

				seconds994392nd = nonComplexTotalTimeSpent - 2400;
				percent994392nd = ((seconds994392nd / 1200) * 100).toFixed(0);
			}

			if (nonComplexTotalTimeSpent >= 3600) {
				seconds99490 = 1200;
				percent99490 = 100;

				seconds994391st = 1200;
				percent994391st = 100;

				seconds994392nd = nonComplexTotalTimeSpent - 2400;
				percent994392nd = 100;
			}

			const complexTotalTimeSpent =
				patient.groupedCcmBillingCodes.cptCode99487?.totalIntervalInSeconds +
				patient.groupedCcmBillingCodes.cptCode99489?.totalIntervalInSeconds;

			if (complexTotalTimeSpent < 3600) {
				seconds99487 = complexTotalTimeSpent;
				percent99487 = ((seconds99487 / 3600) * 100).toFixed(1);

				seconds99489 = 0;
				percent99489 = 0;
			}

			if (complexTotalTimeSpent >= 3600 && complexTotalTimeSpent < 5400) {
				seconds99487 = 3600;
				percent99487 = 100;

				seconds99489 = complexTotalTimeSpent - 3600;
				percent99489 = ((seconds99489 / 1800) * 100).toFixed(0);
			}

			if (complexTotalTimeSpent >= 5400) {
				seconds99487 = 3600;
				percent99487 = 100;

				seconds99489 = complexTotalTimeSpent - 3600;
				percent99489 = 100;
			}

			const physicianTotalTimeSpent =
				patient.groupedCcmBillingCodes.cptCode99491?.totalIntervalInSeconds +
				patient.groupedCcmBillingCodes.cptCode99437?.totalIntervalInSeconds;

			if (physicianTotalTimeSpent < 1800) {
				seconds99491 = physicianTotalTimeSpent;
				percent99491 = ((seconds99491 / 1200) * 100).toFixed(1);

				seconds99437 = 0;
				percent99437 = 0;
			}

			if (physicianTotalTimeSpent >= 1800 && physicianTotalTimeSpent < 3600) {
				seconds99491 = 1800;
				percent99491 = 100;

				seconds99437 = physicianTotalTimeSpent - 1800;
				percent99437 = ((seconds99437 / 1800) * 100).toFixed(0);
			}

			if (physicianTotalTimeSpent >= 3600) {
				seconds99491 = 3600;
				percent99491 = 100;

				seconds99437 = physicianTotalTimeSpent - 1800;
				percent99437 = 100;
			}
		}
		const myBillings = {
			totalMeasurements99453: totalMeasurements99453,
			percent99453: percent99453,
			totalMeasurements99445: totalMeasurements99445,
			percent99445: percent99445,
			totalMeasurements99454: totalMeasurements99454,
			percent99454: percent99454,
			percent99470: percent99470,
			percent99457: percent99457,
			percent994581st: percent994581st,
			percent994582nd: percent994582nd,
			seconds99470: seconds99470,
			seconds99457: seconds99457,
			seconds994581st: seconds994581st,
			seconds994582nd: seconds994582nd,
			m99445IsBillable: measurement99445IsBillable,
			m99454IsBillable: measurement99454IsBillable,
			m99470IsBillable: measurement99470IsBillable,
			m99457IsBillable: measurement99457IsBillable,
			m994581stIsBillable: measurement994581stIsBillable,
			m994582ndIsBillable: measurement994582ndIsBillable,
			totalSeconds: totalSec,
			totalSpentTime: formatDuration(totalSec),
			ccmBillings: {
				ccmNonComplexCptCode: {
					percent99490: percent99490,
					percent994391st: percent994391st,
					percent994392nd: percent994392nd,
					seconds99490: seconds99490,
					seconds994391st: seconds994391st,
					seconds994392nd: seconds994392nd,
				},
				ccmComplexCptCode: {
					percent99487: percent99487,
					percent99489: percent99489,
					seconds99487: seconds99487,
					seconds99489: seconds99489,
				},
				ccmPhysicianCptCode: {
					percent99491: percent99491,
					percent99437: percent99437,
					seconds99491: seconds99491,
					seconds99437: seconds99437,
				},
			},
		};
		patient.myBillings = myBillings;
	});
	return aggregatedData;
}
